







































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import store from '../store';

@Component
export default class DefaultFooter extends Vue {
    @Getter('webSiteUrl', { namespace: 'configuration' }) webSiteUrl;
    @Getter('getUser', { namespace: 'user' }) user: any;
    @Getter('centerDialogVisible', { namespace: 'protocol' }) centerDialogVisible: boolean;
    @Action('getCenterDialogVisible', { namespace: 'protocol' }) getCenterDialogVisible: Function;
    @Action('setCenterDialogVisible', { namespace: 'protocol' }) setCenterDialogVisible: Function;
    private isChecked = false;

    async mounted() {
        document.addEventListener('copy', async event => {
            // 只在详情展示
            if (window.location.href.indexOf('forum') != -1) {
                // 展示协议
                const bool = await this.getCenterDialogVisible(this.user);
                //  未通过不复制
                if (bool) {
                    return;
                }
                // const text = (window.getSelection() as any).toString()
            }
        });
    }

    // 同意协议
    private async successProtocol() {
        // 关闭弹窗且向服务器发送协议状态
        this.setCenterDialogVisible(true);
        // 更新 user store 的 protocol 状态
        const user = JSON.parse(JSON.stringify(this.user));
        user.protocol = 1;
        store.commit('user/setUser', { user });
    }

    // 拒绝协议
    private async handleClose() {
        this.setCenterDialogVisible(false);
        // 给剪切板清空了
        this.$copyText('');
    }
}
